// These polyfills make stable language features of modern ECMAScript
// available accross all target browsers.
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

document
  .querySelectorAll(`[data-${process.env.REACT_APP_NAME}]`)
  .forEach((element: HTMLDivElement) => {
    // Place app inside a shadow dom for JS/CSS isolation.
    // This is just for debugging, as the shadow DOM will be created
    // by Manifest Integration / Microfrontend Integration in the www.ag.ch CMS.
    // Remember to also enable the isolated variant in App.tsx.
    // element.attachShadow({ mode: 'open' });

    // apps may run in 'isolated' mode which means they are in
    // a shadow dom. The react app will then have to be rendered
    // into that shadow dom, too.
    const root = element.shadowRoot
      ? createRoot(element.shadowRoot)
      : createRoot(element);

    root.render(
      React.createElement(App, {
        rootElement: element,
        standalone: element.dataset.standalone === 'true',
        swisscoveryUrl: element.dataset.swisscoveryUrl,
        translationApiUrl: element.dataset.translationApi,
        translationMissingApiUrl: element.dataset.translationMissingApi,
      }),
    );
  });
